import React from "react";

export const AlignComponent = (props : any) => {
    const { id, children, element } = props;
    return (
        <p className={`plate-custom-${element.type}-block slate-p`} id={id}>
            {children}
        </p>
    );
  };